/**
 * External dependencies.
 */
import classNames from "classnames";
import Link from "next/link";
import { localizedLinkProps, linkRel } from "lib/navigation";
import { useRouter } from "next/router";

interface LinkElementProp {
  href: string;
  children: any;
  className?: string;
  title?: string;
  RelNoFollow?: boolean;
  OpenInNewTab?: boolean;
  style?: any;
}

const LinkElement: React.FC<LinkElementProp> = ({
  children,
  href,
  className,
  title,
  RelNoFollow,
  OpenInNewTab,
  style,
}) => {
  const { locale, asPath } = useRouter();
  if (!href) {
    return <></>;
  }
  const linkProps = localizedLinkProps(href, locale);

  return (
    <Link
      {...linkProps}
      target={OpenInNewTab ? "_blank" : "_self"}
      rel={linkRel(RelNoFollow, OpenInNewTab)}
      className={classNames(className, {
        "is-active": asPath === href,
      })}
      title={title}
      style={style}
    >
      {children}
    </Link>
  );
};

export default LinkElement;
